export enum MyBenefitsTabTypes {
  Subscriptions = 0,
  FixedBenefits = 1,
  ExclusiveBenefits = 2,
}

export type MyBenefitsNavigationState = {
  tab?: MyBenefitsTabTypes;
  activeBenefitId?: number;
};
